const size = {
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  notebook: "1200px",
  desktop: "2560px"
};
const device = {
  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  notebook: `(max-width: ${size.notebook})`,
  desktop: `(min-width: ${size.desktop})`,

  ipadPro: `(min-width: 1000px) and (max-width: 1200px) and (min-height: 1300px) and (max-height: 1400px)`,
  ipadAirLandscape: `(min-width: 1150px) and (max-width: 1200px) and (min-height: 800px) and (max-height: 850px) and (orientation:landscape)`,
  ipadLandscape: `(max-width: 1200px) and (max-height: 1000px) and (orientation:landscape)`,
  ipad10Landscape: `(min-width: 1000px) and (max-width: 1100px) and (min-height: 700px) and (max-height: 900px) and (orientation:landscape)`,
  mobileLandscape: `(min-device-width: 320px) and (max-device-width: 900px) and (min-height: 240px) and (max-height: 450px) and (orientation: landscape)`,
  ipadProLandScape: `(min-height: 800px) and (max-height: 1200px) and (min-width: 1200px) and (max-width: 1400px) and (orientation:landscape)`
};

export default device;
